import { api } from "@/lib/api";

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const pushPermission = () => ("Notification" in window ? Notification.permission : "unsupported");

const toUint8 = (b) => {
  const s = atob((b + "=".repeat((4 - (b.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...s].map((c) => c.charCodeAt(0)));
};

export const registerSW = () => ("serviceWorker" in navigator ? navigator.serviceWorker.register("/sw.js") : Promise.resolve(null));

export async function enablePush() {
  if (!pushSupported()) {
    throw new Error(isIOS() && !isStandalone() ? "On iPhone and iPad, add Zunvel to your Home Screen first, then turn on push from the Home Screen app." : "This browser doesn't support push notifications.");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications are blocked for Zunvel. Allow them in your browser's site settings, then try again.");
  await registerSW();
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/carematch/options");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toUint8(data.vapid_public_key) }));
  const j = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: j.endpoint, keys: j.keys, user_agent: navigator.userAgent.slice(0, 300) });
}

export async function disablePush() {
  const reg = await navigator.serviceWorker?.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    await sub.unsubscribe();
  }
}
